// Shared API error helpers for web and mobile.

export const SERVER_DOWN_MESSAGE =
  "Server is unavailable or not responding. Please check that the server is running and try again.";

export const SERVER_TIMEOUT_MESSAGE =
  "The server timed out while processing this request. Please wait a moment and try again.";

/**
 * Normalize error response bodies (plain text or Heroku HTML) into a short user message.
 * @param {string} text
 * @param {string} [fallback]
 */
export function getMessageFromErrorBody(text, fallback = "Something went wrong. Please try again.") {
  const t = text != null ? String(text).trim() : "";
  if (!t) return fallback;
  if (
    /<!doctype html/i.test(t) ||
    /<html[\s>]/i.test(t) ||
    /Application Error/i.test(t) ||
    /herokucdn\.com\/error-pages/i.test(t)
  ) {
    return SERVER_TIMEOUT_MESSAGE;
  }
  // Cap extremely long non-HTML bodies so modals stay readable.
  if (t.length > 500) return `${t.slice(0, 500)}…`;
  return t;
}

export function getMessageForFetchError(
  err,
  fallback = "Something went wrong. Please try again."
) {
  if (!err) return fallback;
  const msg = err && typeof err.message === "string" ? err.message : "";
  const name = err && typeof err.name === "string" ? err.name : "";
  const isServerDown =
    msg === "Failed to fetch" ||
    msg === "unavailable" ||
    (name === "TypeError" &&
      (msg === "" || msg.includes("fetch") || msg.includes("network")));
  if (isServerDown) return SERVER_DOWN_MESSAGE;
  return getMessageFromErrorBody(msg, fallback);
}

export function checkResponse(resp) {
  if (resp.ok) return;
  const status = resp.status;
  if (status === 502 || status === 503 || status === 504) {
    throw new Error("unavailable");
  }
}
